(function() {
    "use strict";
    /**
    *   Plus 3 Interactive CSV Download
    *
    *   fetches an item a the provided href attr and triggers a download
    *   accepts an optional loader, to which it sets the status (true/false)
    */
    angular
        .module("P3in")
        .directive("csvDownload", csvDownload);

    csvDownload.$inject = ["FilterService", "ApiQuery", "$rootScope"];

    function csvDownload(Filters, query, $rootScope) {
        return {
            restrict: "AE",
            priority: 1000,
            scope: {
                loader: '='
            },
            link: function(scope, ele, attrs) {

                ele.bind('click', function(e) {
                    e.preventDefault();

                    scope.loader = true;

                    query(attrs.href, '', 'GET')
                        .then(function(csvData) {
                            scope.loader = false;
                            var supportsDataUri = 'download' in document.createElement('a');
                            if (supportsDataUri) {
                                var a = $('<a/>', {
                                    style:'display:none',
                                    href:'data:application/octet-stream;base64,' + btoa(csvData.data),
                                    download:'repairs-report.csv'
                                }).appendTo('body');
                                a[0].click()
                                a.remove()
                            } else if (window.navigator.msSaveBlob) {
                                var blob = new Blob([csvData],{ type: "application/csv;charset=utf-8;"});
                                navigator.msSaveBlob(blob, 'repairs-report.csv');
                            } else {
                                $rootScope.$broadcast("modal.open", { title: "Error Downloading Data", data: { message: "There were errors while downloading data. Please consider trying a different browser. Sorry about the inconvenience." } } )
                            }
                        })
                        .catch(function() {
                            $rootScope.$broadcast("modal.open", { title: "Error Downloading Data", data: { message: "There were errors while downloading data." } } )
                            scope.loader = false;
                        })
                })
            }
        }
    }
})()


// WEBPACK FOOTER //
// ./src/app/modules/P3in/directives/csv-download.js